import React from "react";

import Table from "../../common/Table";

const BenefitsList = ({ activeYear }) => {

  const paymentsColumn = [
    { path: "id", label: "شماره" },
    { path: "issue_date", label: "تاریخ تایید" },
    { path: "benefit_type", label: "امتیاز" },
    { path: "verified_by_staff_name", label: "تایید کننده" },
    { path: "modified_by_staff_name", label: "ثبت کننده" },
    { path: "amount", label: "مبلغ" },
    { path: "remark", label: "ملاحظه" },
  ];

  const total = activeYear?.benefits?.reduce((sum, item) => sum + parseFloat(item["amount"]), 0);

  return (
  <div className="print-table-area">
    <Table
        data={activeYear?.benefits}
        columns={paymentsColumn}
        total={total}
    />
  </div>
  );
};

export default BenefitsList;
